import { render } from "./ErrorMessages.vue?vue&type=template&id=ab483d34"
import script from "./ErrorMessages.vue?vue&type=script&lang=js"
export * from "./ErrorMessages.vue?vue&type=script&lang=js"
script.render = render

export default script